import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/homepage/homepage.module').then(mod => mod.HomepageModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then(mod => mod.LoginModule),
  },
  {
    path: 'tv-adressee',
    loadChildren: () => import('./features/tv-adressee/tv-adressee.module').then(mod => mod.TvAdresseeModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'tv-lineaire',
    loadChildren: () => import('./features/tv-lineaire/tv-lineaire.module').then(mod => mod.TvLineaireModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'resources',
    loadChildren: () => import('./features/resources/resources.module').then(mod => mod.ResoucesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'popdom',
    loadChildren: () => import('./features/popdom/popdom.module').then(mod => mod.PopDomModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'general-settings',
    loadChildren: () => import('./features/settings/settings.module').then(mod => mod.SettingsModule),

    canActivate: [AuthGuardService],
  },
  {
    path: 'or',
    loadChildren: () => import('./features/or/or.module').then(mod => mod.OrModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'adv',
    loadChildren: () => import('./features/adv/adv.module').then(mod => mod.AdvModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'commercial',
    loadChildren: () => import('./features/commercial/commercial.module').then(mod => mod.CommercialModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'planning',
    loadChildren: () => import('./features/planning/planning.module').then(mod => mod.PlanningModule),
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
